import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { AiOutlinePaperClip } from 'react-icons/ai';

const MAX_FILE_SIZE = 10 * 1024 * 1024;

const AdjuntarFactura = ({ onFilesSelected }) => {
  const { t } = useTranslation(['backoffice']);
  const inputRef = useRef(null);

  const handleFiles = (fileList) => {
    if (!fileList?.length) return;

    const validFiles = Array.from(fileList).filter((file) => file.size <= MAX_FILE_SIZE);
    if (validFiles.length) onFilesSelected(validFiles);
  };

  const handleInputChange = (event) => {
    handleFiles(event.target.files);
    event.target.value = '';
  };

  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();
    handleFiles(event.dataTransfer.files);
  };

  return (
    <section className="order-doc-upload" data-testid="order-adjuntar-factura">
      <h3 className="order-doc-upload__title">{t('orderTrans.attachFactura')}</h3>

      <div
        className="order-doc-upload__dropzone"
        role="button"
        tabIndex={0}
        onClick={() => inputRef.current?.click()}
        onKeyDown={(e) => e.key === 'Enter' && inputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
      >
        <input
          ref={inputRef}
          type="file"
          className="order-doc-upload__input"
          accept=".pdf,.jpg,.jpeg,.png"
          multiple
          onChange={handleInputChange}
        />
        <AiOutlinePaperClip className="order-doc-upload__icon" />
        <p className="order-doc-upload__text">{t('orderTrans.dragFilesHere')}</p>
        <p className="order-doc-upload__hint">{t('orderTrans.fileFormatsHint')}</p>
        <button
          type="button"
          className="order-doc-upload__btn"
          onClick={(e) => {
            e.stopPropagation();
            inputRef.current?.click();
          }}
        >
          {t('orderTrans.selectFiles')}
        </button>
      </div>
    </section>
  );
};

AdjuntarFactura.propTypes = {
  onFilesSelected: PropTypes.func.isRequired,
};

export default AdjuntarFactura;
